import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'

import { Button } from '@dfds-pax/shared-components/client'

interface Props {
  offersShown: boolean
  onClick: () => void
  shown: boolean
}

const StickyButton: React.FC<Props> = ({ offersShown, onClick, shown }) => {
  const { t } = useTranslation()
  const stickyRef = useRef<HTMLDivElement>(null)

  return (
    <div
      className={clsx(
        'fixed left-0 right-0 z-50 flex w-full flex-row bg-semantic-global-background-sand transition-[top] ease-out lg:hidden',
        shown ? 'top-0 shadow-[0_-4px_10px_rgba(0,0,0,0.25)] duration-300' : '-top-[100px] duration-0'
      )}
      data-e2e="sticky-travel-search"
      ref={stickyRef}
    >
      {/* eslint-disable-next-line react-hooks/refs */}
      {stickyRef.current ? (
        <div className="mx-semantic-global-xs w-full px-semantic-global-md">
          <div className="ml-auto flex w-full justify-end py-semantic-global-md md:w-fit">
            <Button size="lg" onClick={onClick}>
              {offersShown ? t('SEE-OFFERS') : t('SEE-PRICES')}
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default StickyButton
